import { Pipe, PipeTransform } from '@angular/core';

import { environment } from '@environment';
import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';
import { MULTIPLES } from '@app/modules/flight-results/constants/filters.constants';

@Pipe({
  name: 'busCompanyImage',
  standalone: false
})
export class BusCompanyImagePipe implements PipeTransform {

  constructor(private imgCdn: ImageCdnPipe) { }

  transform(code: string, netacticaImage?: boolean): string {
    const imgNetacticaCode = code === MULTIPLES ? code : `${code}logo`;
    return code ? netacticaImage ? `${environment.api.images}/BusCompanies/air_${imgNetacticaCode}.gif` :
      this.imgCdn.baseImage(`${code}.png`, 'web/travel/buscompanies') : '';
  }
}
